import { createClient } from '@/clients/http'

const PROVIDER_PAGE_SIZE = 50
const MAX_PROVIDER_PAGES = 20

function mapLocation (location) {
  const addressParts = [location.address_number, location.address_street].filter(Boolean)
  return {
    locationId: location.location_id,
    legacyLocationId: location.legacy_location_id || null,
    legacyPracticeId: location.legacy_practice_id || null,
    name: location.name,
    address1: addressParts.length ? addressParts.join(' ') : null,
    address2: location.address2 || null,
    city: location.city || null,
    state: location.state || null,
    zip: location.zip != null ? String(location.zip) : null
  }
}

function mapProvider (provider) {
  return {
    providerId: provider.provider_id,
    legacyProviderId: provider.legacy_provider_id || null,
    firstName: provider.first_name || '',
    middleName: provider.middle_name || '',
    lastName: provider.last_name || '',
    photoUrl: provider.photo_url || ''
  }
}

export default class PGEntityCoreClient {
  constructor (practiceUuid) {
    this.client = createClient(process.env.VUE_APP_PG_API_DOMAIN)
    this.practiceUuid = practiceUuid
  }

  async getLocations () {
    const { data } = await this.client.get(
      `/v1/practices/${encodeURIComponent(this.practiceUuid)}/locations`
    )
    const locations = Array.isArray(data) ? data : (data.locations || [])
    return { data: { locations: locations.map(mapLocation) } }
  }

  async getProviders (locationUuid) {
    const providers = []
    let pageKey
    let pages = 0
    do {
      const params = { active: true, page_size: PROVIDER_PAGE_SIZE }
      if (pageKey != null) params.page_key = pageKey

      const { data } = await this.client.get(
        `/v2/practices/${encodeURIComponent(this.practiceUuid)}/locations/${encodeURIComponent(locationUuid)}/providers`,
        { params }
      )
      providers.push(...(data.providers || []))
      const nextKey = data.page && data.page.next_page_key
      if (nextKey != null && nextKey === pageKey) break
      pageKey = nextKey
      pages += 1
    } while (pageKey != null && pages < MAX_PROVIDER_PAGES)

    return { data: { providers: providers.map(mapProvider) } }
  }
}
